import { getPreviousPhaseAndStep, getNextActivePhaseAndStep } from '../utils';

export const getters = {
  phases: (state) => state.phases,
  /* Using id from route phase as on step change route number will also change */
  currentPhase: (state) => state.activePhase,
  currentStep: (state) => state.activeStep,

  currentPhaseObject: (state) => {
    const activePhase = state.activePhase;
    return state.phases[activePhase];
  },
  stepToPrint: (state) => {
    const activePhase = state.activePhase;
    const activeStep = state.activeStep;
    return state.phases[activePhase].Steps[activeStep].isPrintEnable;
  },
  phasesToDisplay: (state) => {
    const unhiddenPhases = state.phases.filter((phase) => !phase.HidePhase && !phase.isPhaseHidden);
    return unhiddenPhases.filter((phase) => phase.Steps.filter((step) => !step.isStepHidden).length > 0);
  },
  stepsToDisplay: (state) => {
    const activePhase = state.activePhase;

    return (state.phases[activePhase] || {}).Steps.filter((step) => {
      if (step.HideStep) {
        return false;
      }
      return !step.isStepHidden;
    });
  },
  disabledPhases: (state) => (wizardDetails) => {
    const activePhase = state.activePhase;

    // Returns array that specifies disabled phases
    return state.phases.map(
      (phase, index) =>
        state.waitForActionFlowCompletion ||
        (activePhase > index ? state.disablePrevious : state.disableNext) ||
        wizardDetails.BlockPhaseNavigation
    );
  },
  disabledSteps: (state, getters) => {
    const activeStep = state.activeStep;
    const phaseObject = getters.currentPhaseObject;

    // Returns array that specifies disabled steps
    return phaseObject.Steps.map(
      (step, index) =>
        state.waitForActionFlowCompletion ||
        (activeStep > index ? state.disablePrevious : state.disableNext) ||
        activeStep === index ||
        phaseObject.BlockNavigation
    );
  },

  previousStepDetails: (state) =>
    getPreviousPhaseAndStep(state.phases, {
      currentPhase: state.activePhase,
      currentStep: state.activeStep - 1
    }),

  nextStepDetails: (state) =>
    getNextActivePhaseAndStep(state.phases, {
      currentPhase: state.activePhase,
      currentStep: state.activeStep + 1
    }),

  record: (state) => state.record
};
